export default "__VITE_ASSET__DjVdpYrW__"